<template>
  <div>
    <div class="title-card">
      <h1>Collectio</h1>
      <h3>〜 みんなで読む読書 〜</h3>
      <a href="/about">Collectioとは？</a>
    </div>

    <div class="carousel-book">
      <h3>おすすめの本</h3>
      <b-carousel controls indicators :interval="5000" class="carousel">
        <b-carousel-slide
          img-blank
          v-for="(slide, index) in books"
          :key="index"
        >
          <div class="flex-row">
            <BookCard
              :book="book"
              v-for="(book, index) in slide"
              :key="index"
              class="carousel-card"
            />
          </div>
        </b-carousel-slide>
      </b-carousel>
    </div>

    <div class="carousel-question">
      <h3>おすすめの問い</h3>
      <b-carousel controls indicators :interval="5000">
        <b-carousel-slide
          img-blank
          v-for="(question, index) in questions"
          :key="index"
        >
          <QuestionCard :question="question" class="carousel-card" />
        </b-carousel-slide>
      </b-carousel>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { db } from "@/firebase";
import BookCard from "../components/BookCard.vue";
import QuestionCard from "@/components/QuestionCard.vue";

export default {
  data: function() {
    return {
      books: [],
      questions: [],
      isDark: this.$store.getters.user.isDark,
      backgroundImageSrc: "",
      isTop: true,
      windowWidth: window.innerWidth
    };
  },
  components: {
    BookCard,
    QuestionCard
  },
  methods: {
    fetchData() {
      db.collection("books")
        .orderBy("favCount", "desc")
        .limit(6)
        .get()
        .then(snapshots => {
          let slideNum = 0;
          this.books.push([]);
          snapshots.docs.forEach((snapshot, index) => {
            const book = snapshot.data();
            book.id = snapshot.id;
            this.books[slideNum].push(book);
            if (index != 5) {
              if (this.windowWidth < 560) {
                slideNum++;
                this.books.push([]);
              } else if (this.windowWidth < 960) {
                if (index % 2 == 1) {
                  slideNum++;
                  this.books.push([]);
                }
              } else {
                if (index % 3 == 2) {
                  slideNum++;
                  this.books.push([]);
                }
              }
            }
          });
        });
      db.collection("questions")
        .orderBy("favCount", "desc")
        .limit(4)
        .get()
        .then(snapshots => {
          snapshots.docs.forEach(snapshot => {
            const question = snapshot.data();
            question.id = snapshot.id;
            this.questions.push(question);
          });
        });
    }
  },
  created() {
    this.fetchData();
    this.$root.$on("onTopPage", function() {
      document.body.classList.remove("about-bg");
      if (this.$store.getters.user.isDark) {
        console.log("Good Evening");
        document.body.classList.add("is-top-dark");
      } else {
        console.log("Good Morning");
        document.body.classList.add("is-top-light");
      }
    });
  },
  mounted() {
    this.$root.$emit("onTopPage");
  }
};
</script>

<style lang="scss">
.title-card {
  margin: 20px 0;
  padding: 20px;
  width: 85%;
  min-width: 346px;
  text-align: left;
  background-color: rgba(242, 243, 237, 0.678);
  width: 55%;
  border-radius: 5px;
  color: #2c3e50;
  font-family: "Times New Roman", Times, serif;
  h1 {
    font-weight: 40px;
    padding: 10px 20px;
  }
  h3 {
    padding: 0 50px;
  }
  a {
    padding: 0 50px;
  }
}

.carousel-card {
  color: #2c3e50;
  width: 100%;
}
.carousel-book {
  .img-fluid {
    height: 490px !important;
  }
}
.carousel-question {
  .img-fluid {
    height: 500px !important;
    @media screen and(max-width: 560px) {
      height: 600px !important;
    }
  }
}
.is-top-light {
  background-image: url("../assets/wisdom-light.jpg");
  background-attachment: fixed;
  background-size: cover;
}
.is-top-dark {
  background-image: url("../assets/wisdom-dark.jpg");
  background-attachment: fixed;
  background-size: cover;
}
</style>
